
<template id="questions-course-subject-page">
  <div class="is-100-vw">
    <ToastPrime position="top-right" />
    <!-- Dropdowns for selecting Course and Subject -->
    <div class="container mt-4">
      <div class="columns">
        <div class="column is-6">
          <CursoDropdown
            v-model="selectedCurso"
            :mostrarErrores="mostrarErrores"
            @update:modelValue="onCursoChange"
          />
        </div>
        <div class="column is-6">
          <AsignaturaDropdown
            v-model="selectedAsignatura"
            :mostrarErrores="mostrarErrores"
            @update:modelValue="onAsignaturaChange"
          />
        </div>
      </div>
    </div>

    <br />

    <!-- Stop Button and Progress for Questions -->
    <div v-if="isFetching" class="container mt-4">
      <div class="columns is-vcentered">
        <div class="column is-6">
          <p class="has-text-grey is-size-5">
            Procesando capítulo {{ currentChapterIndex + 1 }} de {{ totalChapters }}...
          </p>
        </div>
        <div class="column is-6 has-text-right">
          <ButtonPrime
            label="Detener Proceso"
            icon="pi pi-stop"
            class="p-button-danger"
            @click="stopFetching"
            :disabled="!isFetching"
          />
        </div>
      </div>
    </div>

    <!-- Questions Table -->
    <div v-if="questions.length" class="container mt-4">
      <h3 class="is-size-4 has-text-weight-bold mb-4">Preguntas para el Curso y Asignatura Seleccionados</h3>
      <DataTablePrime
        :value="questions"
        :paginator="true"
        :rows="10"
        :rowsPerPageOptions="[5, 10, 20, 50]"
        responsiveLayout="scroll"
        class="p-datatable-sm"
        dataKey="id_pregunta"
        :loading="isFetching"
      >
        <ColumnPrime header="ID Pregunta" sortable field="id_pregunta">
          <template #body="slotProps">
            {{ slotProps.data.id_pregunta }}
          </template>
        </ColumnPrime>
        <ColumnPrime header="Glosa (pregunta)" sortable field="Pregunta" :style="{ minWidth: '20rem' }">
          <template #body="slotProps">
            <div class="descripcion-imagen-editor glosa-col">
              <TextareaPrime
                class="w-full"
                :modelValue="glosaEnTabla(slotProps.data)"
                rows="4"
                autoResize
                placeholder="Glosa / enunciado de la pregunta"
                @update:modelValue="(v) => onGlosaDraftChange(slotProps.data, v)"
              />
              <ButtonPrime
                label="Guardar glosa"
                icon="pi pi-save"
                class="p-button-secondary p-button-sm"
                :loading="savingGlosaById[preguntaIdKey(slotProps.data)]"
                @click="guardarGlosaPregunta(slotProps.data)"
              />
            </div>
          </template>
        </ColumnPrime>
        <ColumnPrime header="Alternativas">
          <template #body="slotProps">
            {{ slotProps.data.Alternativas }}
          </template>
        </ColumnPrime>
        <ColumnPrime header="Grado de Dificultad" sortable field="Dificultad">
          <template #body="slotProps">
            {{ mapDificultadToText(slotProps.data.Dificultad) }}
          </template>
        </ColumnPrime>
        <ColumnPrime header="Habilidad" sortable field="Habilidad">
          <template #body="slotProps">
            {{ mapHabilidadToText(slotProps.data.Habilidad) }}
          </template>
        </ColumnPrime>
        <ColumnPrime header="Unidad" sortable field="UnidadId">
          <template #body="slotProps">
            {{ getUnidadName(slotProps.data.UnidadId) }}
          </template>
        </ColumnPrime>
        <ColumnPrime header="Capítulo" sortable field="IdCapitulo">
          <template #body="slotProps">
            {{ getCapituloName(slotProps.data.IdCapitulo) }}
          </template>
        </ColumnPrime>
        <ColumnPrime header="Solución" field="Solucion">
          <template #body="slotProps">
            {{ slotProps.data.Solucion || 'N/A' }}
          </template>
        </ColumnPrime>
        <ColumnPrime field="ImagenPregunta" header="Imagen (ruta y enlace)" :style="{ minWidth: '22rem' }">
          <template #body="slotProps">
            <div class="image-container">
              <img
                style="width:150px; height:150px; object-fit:contain;"
                v-if="getImagenPreguntaPath(slotProps.data)"
                :key="`${slotProps.data.id_pregunta}-${getImagenPreguntaPath(slotProps.data)}`"
                :src="getImagenPreguntaUrl(getImagenPreguntaPath(slotProps.data))"
                alt="Imagen Pregunta"
                referrerpolicy="no-referrer"
                @error="slotProps.data.imageBroken = true"
                @load="slotProps.data.imageBroken = false"
              />
              <span v-else class="no-image">Sin imagen</span>
              <div v-if="getImagenPreguntaPath(slotProps.data)" class="imagen-ruta-url">
                <p class="imagen-ruta-label">ImagenPregunta (valor en BD)</p>
                <code class="imagen-ruta-text" :title="getImagenPreguntaPath(slotProps.data)">{{ getImagenPreguntaPath(slotProps.data) }}</code>
                <a
                  :href="getImagenPreguntaUrl(getImagenPreguntaPath(slotProps.data))"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="imagen-url-completa"
                >
                  {{ getImagenPreguntaUrl(getImagenPreguntaPath(slotProps.data)) }}
                </a>
                <span v-if="slotProps.data.imageBroken === true" class="imagen-miniatura-rota">Miniatura no cargó; el enlace sigue siendo válido.</span>
              </div>
              <ButtonPrime
                label="Subir Imagen"
                icon="pi pi-upload"
                class="p-button-info p-button-sm mt-2"
                @click="openUploadModal(slotProps.data)"
              />
            </div>
          </template>
        </ColumnPrime>
        <ColumnPrime header="Texto de imagen">
          <template #body="slotProps">
            <div class="descripcion-imagen-editor">
              <TextareaPrime
                v-model="slotProps.data.DescripcionImagenPregunta"
                rows="3"
                autoResize
                placeholder="Descripción de imagen (accesibilidad)"
              />
              <ButtonPrime
                label="Guardar texto"
                icon="pi pi-save"
                class="p-button-success p-button-sm"
                :loading="savingDescriptionById[slotProps.data.id_pregunta]"
                @click="guardarDescripcionImagen(slotProps.data)"
              />
            </div>
          </template>
        </ColumnPrime>
        <ColumnPrime header="Estado">
          <template #body="slotProps">
            <ButtonPrime
              label="Desactivar"
              icon="pi pi-times-circle"
              class="p-button-danger p-button-sm"
              :loading="deactivatingById[slotProps.data.id_pregunta]"
              @click="desactivarPregunta(slotProps.data)"
            />
          </template>
        </ColumnPrime>
        <ColumnPrime header="Video Asociado" field="IdVideo">
          <template #body="slotProps">
            {{ getVideoName(slotProps.data.IdVideo) }}
          </template>
        </ColumnPrime>
      </DataTablePrime>
    </div>

    <!-- Empty State -->
    <div v-else-if="!isFetching && selectedCurso.length && selectedAsignatura.length && !isError" class="container mt-4">
      <p class="has-text-grey is-size-5">No se encontraron preguntas para el curso y asignatura seleccionados.</p>
    </div>

    <!-- Error State -->
    <div v-if="isError" class="container mt-4">
      <p class="has-text-danger is-size-5">{{ errorMessage }}</p>
      <ButtonPrime
        label="Reintentar"
        icon="pi pi-refresh"
        class="p-button-info mt-2"
        @click="retryFetch"
      />
    </div>

    <!-- Loading State -->
    <div v-if="isFetching && !questions.length" class="container mt-4">
      <p class="has-text-grey is-size-5">Cargando preguntas...</p>
    </div>

    <!-- Upload Image Modal -->
    <DialogPrime
      :visible="showUploadModal"
      @update:visible="showUploadModal = $event"
      header="Subir Nueva Imagen"
      :modal="true"
      :style="{ width: '50vw' }"
    >
      <SubirImagen
        :idVideo="selectedQuestion?.IdVideo"
        :idPregunta="selectedQuestion?.id_pregunta"
        :idCapitulo="selectedQuestion?.IdCapitulo"
        @image-uploaded="handleImageUploaded"
        @upload-error="handleUploadError"
      />
      <template #footer>
        <ButtonPrime
          label="Cerrar"
          icon="pi pi-times"
          class="p-button-secondary"
          @click="showUploadModal = false"
        />
      </template>
    </DialogPrime>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PreguntaService from '@/services/PreguntaService';
import SobjectService from '@/services/SobjectService';
import CursoDropdown from '@/components/selectores/CursoDropdown.vue';
import AsignaturaDropdown from '@/components/selectores/AsignaturaDropdown.vue';
import DataTablePrime from 'primevue/datatable';
import ColumnPrime from 'primevue/column';
import ButtonPrime from 'primevue/button';
import DialogPrime from 'primevue/dialog';
import TextareaPrime from 'primevue/textarea';
import ToastPrime from 'primevue/toast';
import SubirImagen from '@/components/SubirImagen.vue';

export default {
  name: 'questions-course-subject-page',
  components: {
    CursoDropdown,
    AsignaturaDropdown,
    DataTablePrime,
    ColumnPrime,
    ButtonPrime,
    DialogPrime,
    TextareaPrime,
    ToastPrime,
    SubirImagen,
  },
  data() {
    return {
      selectedCurso: [],
      selectedAsignatura: [],
      mostrarErrores: false,
      subject: null,
      questions: [],
      isFetching: false,
      isError: false,
      errorMessage: '',
      shouldStop: false,
      currentChapterIndex: 0,
      totalChapters: 0,
      showUploadModal: false,
      selectedQuestion: null,
      savingDescriptionById: {},
      savingGlosaById: {},
      deactivatingById: {},
    };
  },
  methods: {
    toastNotify(severity, summary, detail, life = 4500) {
      this.$toast?.add?.({ severity, summary, detail: detail || '', life });
    },
    /** Clave estable para maps de loading (evita mismatch string/number). */
    preguntaIdKey(row) {
      if (!row) return '';
      const id = row.id_pregunta;
      return id != null && id !== '' ? String(id) : '';
    },
    glosaEnTabla(row) {
      return row?.Pregunta != null ? String(row.Pregunta) : '';
    },
    onGlosaDraftChange(row, texto) {
      const key = this.preguntaIdKey(row);
      if (!key) return;
      const idx = this.questions.findIndex(q => String(q.id_pregunta) === key);
      if (idx === -1) return;
      this.questions[idx].Pregunta = texto != null ? String(texto) : '';
    },
    async getChaptersAndQuestions(id_curso, id_asignatura) {
      console.log('Iniciando obtención de capítulos y preguntas para curso:', id_curso, 'y asignatura:', id_asignatura);
      this.isFetching = true;
      this.isError = false;
      this.errorMessage = '';
      this.questions = [];
      this.shouldStop = false;
      this.currentChapterIndex = 0;
      this.$store.dispatch('form/submit', true);

      try {
        const response = await SobjectService.getDataSubjects(id_curso, id_asignatura);
        console.log('Respuesta de capítulos:', response.data);
        this.subject = response.data;
        const chapters = this.subject.Capitulos || [];
        this.totalChapters = chapters.length;

        if (!chapters.length) {
          console.log('No se encontraron capítulos');
          this.isFetching = false;
          this.$store.dispatch('form/submit', false);
          return;
        }

        for (let i = 0; i < chapters.length; i++) {
          if (this.shouldStop) {
            console.log('Proceso detenido por el usuario');
            this.isFetching = false;
            this.$store.dispatch('form/submit', false);
            return;
          }

          this.currentChapterIndex = i;
          const chapter = chapters[i];
          console.log(`Procesando capítulo ${chapter.IdCapitulo} con unidad ${chapter.UnidadId}`);

          try {
            const questionResponse = await PreguntaService.getQuestionsByUnitAndChapter({
              idEjeTematico: chapter.UnidadId,
              idCapitulo: chapter.IdCapitulo,
            });
            const chapterQuestions = questionResponse.data || [];
            console.log(`Preguntas para unidad ${chapter.UnidadId} y capítulo ${chapter.IdCapitulo}:`, chapterQuestions);

            chapterQuestions.forEach(q => {
              if (!this.questions.some(existing => existing.id_pregunta === q.id_pregunta)) {
                this.questions.push({
                  id_pregunta: q.id_pregunta || q.IdPregunta,
                  Pregunta: q.Pregunta != null && String(q.Pregunta).trim() !== '' ? String(q.Pregunta) : (q.Glosa != null ? String(q.Glosa) : ''),
                  Alternativas: this.formatAlternativas(q),
                  Dificultad: q.Dificultad || q.IdDificultad,
                  Habilidad: q.Habilidad || q.IdHabilidad,
                  UnidadId: chapter.UnidadId,
                  IdCapitulo: chapter.IdCapitulo,
                  Solucion: q.Solucion || q.GlosaSolucion || 'N/A',
                  ImagenPregunta: this.pickImagenPreguntaFromApi(q),
                  DescripcionImagenPregunta: q.DescripcionImagenPregunta || q.descripcion_imagen_pregunta || '',
                  IdVideo: q.IdVideo || null,
                  imageBroken: false,
                });
              }
            });
          } catch (error) {
            console.error(`Error al obtener preguntas para unidad ${chapter.UnidadId} y capítulo ${chapter.IdCapitulo}:`, error);
            this.errorMessage = `Error al cargar preguntas para el capítulo ${chapter.Glosa || chapter.IdCapitulo}: ${error.message}`;
          }
        }

        if (this.questions.length === 0 && !this.errorMessage) {
          console.log('No se encontraron preguntas para los capítulos');
        } else {
          console.log('Todas las preguntas obtenidas:', this.questions);
        }
      } catch (error) {
        console.error('Error al obtener los capítulos:', error);
        this.isError = true;
        this.errorMessage = 'Error al cargar los capítulos: ' + error.message;
      } finally {
        this.isFetching = false;
        this.$store.dispatch('form/submit', false);
      }
    },

    formatAlternativas(question) {
      const alternativas = [
        { glosa: question.GlosaAlter1, correcta: question.CFAlter1 },
        { glosa: question.GlosaAlter2, correcta: question.CFAlter2 },
        { glosa: question.GlosaAlter3, correcta: question.CFAlter3 },
        { glosa: question.GlosaAlter4, correcta: question.CFAlter4 },
      ].filter(a => a.glosa);
      return alternativas
        .map((a, index) => `${index + 1}: ${a.glosa} (${a.correcta ? 'Correcta' : 'Incorrecta'})`)
        .join(', ');
    },

    openUploadModal(question) {
      this.selectedQuestion = question;
      this.showUploadModal = true;
    },

    handleImageUploaded({ idPregunta, newImageUrl }) {
      const pid = Number(idPregunta);
      this.questions = this.questions.map(q =>
        Number(q.id_pregunta) === pid
          ? { ...q, ImagenPregunta: newImageUrl || q.ImagenPregunta, imageBroken: false }
          : q
      );
      this.showUploadModal = false;
      this.selectedQuestion = null;
      alert('Imagen subida exitosamente.');
    },

    handleUploadError(errorMessage) {
      alert(`Error al subir la imagen: ${errorMessage}`);
    },

    async guardarDescripcionImagen(question) {
      const idPregunta = question.id_pregunta;
      this.savingDescriptionById = {
        ...this.savingDescriptionById,
        [idPregunta]: true,
      };
      try {
        await PreguntaService.actualizarDescripcionImagenPregunta(
          idPregunta,
          question.DescripcionImagenPregunta || null
        );
        alert('Texto de imagen guardado correctamente.');
      } catch (error) {
        alert(`Error al guardar texto de imagen: ${error.message}`);
      } finally {
        this.savingDescriptionById = {
          ...this.savingDescriptionById,
          [idPregunta]: false,
        };
      }
    },

    async guardarGlosaPregunta(question) {
      const idKey = this.preguntaIdKey(question);
      const idPregunta = Number(question.id_pregunta);
      if (!Number.isFinite(idPregunta) || idPregunta <= 0) {
        this.toastNotify('warn', 'Glosa', 'ID de pregunta no válido.');
        return;
      }
      const texto = (this.glosaEnTabla(question) || '').trim();
      if (!texto) {
        this.toastNotify('warn', 'Glosa', 'El texto no puede quedar vacío.');
        return;
      }
      this.savingGlosaById = {
        ...this.savingGlosaById,
        [idKey]: true,
      };
      try {
        await PreguntaService.actualizarGlosaPregunta(idPregunta, texto);
        this.onGlosaDraftChange(question, texto);
        this.toastNotify('success', 'Glosa guardada', `Pregunta ${idPregunta} actualizada.`);
      } catch (error) {
        this.toastNotify('error', 'Error al guardar', error.message || 'No se pudo guardar la glosa.');
      } finally {
        this.savingGlosaById = {
          ...this.savingGlosaById,
          [idKey]: false,
        };
      }
    },

    async desactivarPregunta(question) {
      const idPregunta = question.id_pregunta;
      const confirmado = window.confirm(`¿Desactivar la pregunta ${idPregunta}?`);
      if (!confirmado) {
        return;
      }

      this.deactivatingById = {
        ...this.deactivatingById,
        [idPregunta]: true,
      };

      try {
        await PreguntaService.desactivarPregunta(idPregunta);
        this.questions = this.questions.filter(q => q.id_pregunta !== idPregunta);
        alert('Pregunta desactivada correctamente.');
      } catch (error) {
        alert(`Error al desactivar: ${error.message}`);
      } finally {
        this.deactivatingById = {
          ...this.deactivatingById,
          [idPregunta]: false,
        };
      }
    },

    async onCursoChange(newValue) {
      console.log('Curso seleccionado:', newValue);
      this.selectedCurso = newValue;
      if (this.selectedCurso.length && this.selectedAsignatura.length) {
        await this.getChaptersAndQuestions(this.selectedCurso[0], this.selectedAsignatura[0]);
      } else {
        this.questions = [];
        this.subject = null;
      }
    },

    async onAsignaturaChange(newValue) {
      console.log('Asignatura seleccionada:', newValue);
      this.selectedAsignatura = newValue;
      if (this.selectedCurso.length && this.selectedAsignatura.length) {
        await this.getChaptersAndQuestions(this.selectedCurso[0], this.selectedAsignatura[0]);
      } else {
        this.questions = [];
        this.subject = null;
      }
    },

    stopFetching() {
      console.log('Usuario solicitó detener el proceso');
      this.shouldStop = true;
      this.isFetching = false;
      alert('La obtención de preguntas ha sido detenida.');
    },

    retryFetch() {
      if (this.selectedCurso.length && this.selectedAsignatura.length) {
        this.getChaptersAndQuestions(this.selectedCurso[0], this.selectedAsignatura[0]);
      }
    },

    mapHabilidadToText(idHabilidad) {
      const habilidades = {
        1: 'Aplicar',
        2: 'Comprender',
        3: 'Analizar',
        4: 'Recordar',
      };
      return habilidades[idHabilidad] || 'Desconocida';
    },

    mapDificultadToText(idDificultad) {
      const dificultades = {
        1: 'Fácil',
        2: 'Intermedio',
        3: 'Difícil',
      };
      return dificultades[idDificultad] || 'Desconocida';
    },

    getUnidadName(unidadId) {
      if (!this.subject || !this.subject.Capitulos) return 'N/A';
      const capitulo = this.subject.Capitulos.find(c => c.UnidadId === unidadId);
      return capitulo ? capitulo.UnidadGrupo : 'N/A';
    },

    getCapituloName(idCapitulo) {
      if (!this.subject || !this.subject.Capitulos) return 'N/A';
      const capitulo = this.subject.Capitulos.find(c => c.IdCapitulo === idCapitulo);
      return capitulo ? capitulo.Glosa : 'N/A';
    },

    getVideoName(idVideo) {
      if (!this.subject || !this.subject.VideosCapitulo) return 'N/A';
      const video = this.subject.VideosCapitulo.find(v => v.IdVideo === idVideo);
      return video ? video.Glosa : 'N/A';
    },

    /** Valor ImagenPregunta / link_imagen según venga el API (PascalCase, camelCase, etc.). */
    pickImagenPreguntaFromApi(q) {
      if (!q || typeof q !== 'object') return '';
      const keys = [
        'ImagenPregunta',
        'imagenPregunta',
        'LinkImagenPregunta',
        'linkImagenPregunta',
        'link_imagen_pregunta',
      ];
      for (const k of keys) {
        const v = q[k];
        if (v != null && String(v).trim() !== '') return String(v).trim();
      }
      return '';
    },

    /** Ruta ya normalizada en la fila de la tabla (tras mapeo o subida). */
    getImagenPreguntaPath(row) {
      if (!row) return '';
      const v =
        row.ImagenPregunta ??
        row.imagenPregunta ??
        row.LinkImagenPregunta ??
        row.linkImagenPregunta;
      if (v != null && String(v).trim() !== '') return String(v).trim();
      return '';
    },

    /** URL pública de la imagen (mismo prefijo que el resto del admin). */
    getImagenPreguntaUrl(relativePath) {
      if (relativePath == null || String(relativePath).trim() === '') return '';
      const base = 'https://estudyoo.cl/v1/';
      const rel = String(relativePath).replace(/^\/+/, '');
      return base + rel;
    },
  },

  created() {
    if (this.$route.params.curso_id && this.$route.params.asignatura_id) {
      console.log('Inicializando con parámetros de ruta:', this.$route.params);
      this.selectedCurso = [this.$route.params.curso_id];
      this.selectedAsignatura = [this.$route.params.asignatura_id];
      this.getChaptersAndQuestions(this.selectedCurso[0], this.selectedAsignatura[0]);
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      token: 'auth/access-token',
    }),
  },
};
</script>

<style scoped>
.is-100-vw {
  width: 100vw;
}

.container {
  padding: 0 1rem;
}

.p-datatable-sm {
  font-size: 0.875rem;
}

.p-datatable .p-datatable-thead > tr > th {
  background-color: #007bff;
  color: white;
  font-weight: 600;
}

.p-datatable .p-datatable-tbody > tr:hover {
  background-color: #f1f3f5;
}

.p-button-danger,
.p-button-info,
.p-button-success {
  padding: 0.5rem 1rem;
}

.image-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  max-width: 28rem;
}

.no-image {
  color: #6c757d;
}

.imagen-ruta-url {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  text-align: left;
  width: 100%;
}

.imagen-ruta-label {
  margin: 0;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #6c757d;
}

.imagen-ruta-text {
  display: block;
  font-size: 0.75rem;
  line-height: 1.35;
  word-break: break-all;
  white-space: pre-wrap;
  padding: 0.35rem 0.5rem;
  background: #f4f6f8;
  border-radius: 4px;
  margin: 0;
}

.imagen-url-completa {
  font-size: 0.75rem;
  line-height: 1.35;
  word-break: break-all;
  color: #007bff;
  text-decoration: underline;
}

.imagen-url-completa:hover {
  color: #0056b3;
}

.imagen-miniatura-rota {
  font-size: 0.7rem;
  color: #c92a2a;
}

.p-button-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.descripcion-imagen-editor {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 260px;
}

.glosa-col :deep(.p-inputtextarea) {
  width: 100%;
  min-width: 0;
}
</style>